{
  "fr": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Ajouter une personne assignée",
        "bulk_remove": "Retirer",
        "confirm": "Marquer comme terminé",
        "delete": "Supprimer la personne assignée",
        "document_add": "Ajouter un fichier",
        "document_delete": "Supprimer",
        "due_in_month": "Dans un mois",
        "due_in_two_weeks": "Dans deux semaines",
        "due_in_week": "Dans une semaine",
        "due_remove": "Supprimer l'échéance",
        "open": "Ouvrir",
        "reopen": "Rouvrir",
        "selectAll": "Tout sélectionner ({total})",
        "send_and_notify": "Envoyer et notifier",
        "set_due_date": "Définir l'échéance",
        "set_status": "Définir le statut",
        "unSelectAll": "Désélectionner tout",
        "upload_files": "Téléverser {count} fichier | Téléverser {count} fichiers"
      },
      "assignee_scopes": {
        "external": "Externe",
        "internal": "Interne"
      },
      "assignee_types": {
        "customer": "Client",
        "employee": "Membre de l'équipe",
        "partner": "Partenaire"
      },
      "attributes": {
        "assignee": "Personne assignée",
        "assignees": "Personnes assignées",
        "comment": "Commentaire",
        "created_at": "Créé",
        "document": "Document",
        "due_date": "Échéance",
        "project": "Projet",
        "status": "Statut",
        "task": "Tâche",
        "unit": "Unité"
      },
      "confirm": {
        "assignees_count": "{count} personne assignée | {count} personnes assignées",
        "bulk_delete_accept": "Retirer",
        "bulk_delete_body": "Cela supprime leur tâche pour ces unités. La tâche elle-même et les autres personnes assignées gardent la leur.",
        "bulk_delete_body_project": "Cela supprime leur tâche. La tâche elle-même et les autres personnes assignées gardent la leur.",
        "bulk_delete_header": "Retirer {count} personne assignée ? | Retirer {count} personnes assignées ?",
        "complete_accept": "Tout terminer",
        "complete_body": "Cela passe {assignees} en {status}, y compris les tâches que le client n'a pas encore terminées lui-même. Elles passent dans les tâches terminées de leur liste.",
        "complete_header": "Tout passer en terminé ?",
        "customer_tasks": "{count} tâche client | {count} tâches client",
        "customers_and_team": "{customers} et {team}",
        "delete_body": "Cela supprime leur tâche pour cette unité. Les autres unités et personnes assignées gardent la leur.",
        "delete_body_project": "Cela supprime leur tâche. Les autres personnes assignées gardent la leur.",
        "delete_header": "Retirer {name} de {unit} ?",
        "delete_header_project": "Retirer {name} de cette tâche ?",
        "delete_sent_customers": "Celle-ci a déjà été envoyée, elle disparaît donc aussi du portail des clients.",
        "delete_sent_team": "Celle-ci a déjà été envoyée, elle disparaît donc aussi de la liste de {name}.",
        "document_delete_body": "Le fichier disparaît aussi des documents de l'unité.",
        "document_delete_body_project": "Le fichier disparaît aussi des documents du projet.",
        "document_delete_header": "Supprimer ce fichier ?",
        "draft_accept": "Tout remettre en brouillon",
        "draft_body": "Cela remet {assignees} en {status}. La tâche disparaît de la liste du client jusqu'à ce que tu la renvoies. Les e-mails déjà partis restent envoyés.",
        "draft_header": "Tout remettre en brouillon ?",
        "send_body": "Cela passe {who} en {status}.",
        "send_customers": "Les clients voient la tâche tout de suite dans leur portail et reçoivent un e-mail à ce sujet.",
        "send_header": "Envoyer cette tâche ? | Envoyer ces tâches ?",
        "send_permanent": "Tu peux les remettre en Brouillon plus tard, mais la notification sera déjà partie.",
        "send_team": "Les membres de l'équipe voient la tâche sur leur tableau de bord et sont prévenus.",
        "tasks_count": "{count} tâche | {count} tâches",
        "team_tasks": "{count} tâche d'équipe | {count} tâches d'équipe"
      },
      "deep_link": {
        "completed": "Cette tâche est déjà effectuée.",
        "gone": "Cette tâche n'est plus ouverte."
      },
      "empty": {
        "filtered_description": "Ajuste tes filtres ou efface-les pour voir toutes les assignations.",
        "filtered_title": "Aucune assignation ne correspond à tes filtres",
        "none_title": "Aucune assignation"
      },
      "filters": {
        "assignee_any": "Toute personne assignée",
        "clear_all": "Effacer tous les filtres",
        "done": "Terminé",
        "due_window_values": {
          "none": "Pas d'échéance",
          "overdue": "En retard",
          "set": "Avec échéance"
        },
        "phase_any": "Toute phase",
        "show_only": "Afficher uniquement",
        "show_only_values": {
          "customers": "Clients",
          "mine": "Qui me sont assignées",
          "team": "Équipe"
        },
        "unit_any": "Toute unité"
      },
      "labels": {
        "add_assignee": "Ajouter une personne assignée",
        "add_customers": "Ajouter des clients",
        "already_assigned": "Cette tâche est déjà ajoutée à cette unité.",
        "already_assigned_project": "Cette tâche est déjà ajoutée à ce projet.",
        "assignees_subtitle": "Chacun reçoit sa propre tâche, par unité.",
        "assignees_title": "Qui doit s'en charger",
        "comment_earlier_round": "tour précédent",
        "comment_placeholder": "p. ex. le compteur était difficile d'accès, voici la meilleure photo possible",
        "comments_none": "Le client n'a laissé aucun commentaire.",
        "comments_title": "Commentaires sur cette tâche",
        "completed": "Terminées",
        "completed_tasks": "Tâches terminées",
        "confirm_message": "Voulez-vous vraiment marquer cette tâche comme terminée ?",
        "customers": "Clients",
        "documents_none": "Rien n'a encore été téléversé.",
        "documents_title": "Fichiers de cette tâche",
        "earlier": "+{count} plus tôt",
        "my_tasks": "Mes tâches",
        "no_assignees": "Aucune personne assignée pour le moment.",
        "no_assignments": "Les tâches qui te sont assignées apparaissent ici.",
        "no_assignments_task": "Aucune assignation pour cette tâche pour le moment.",
        "previous_upload": "Téléversement précédent",
        "required": "Ce champ est obligatoire",
        "selectOne": "Sélectionnez au moins une tâche.",
        "select_task": "Sélectionner une tâche",
        "selected": "{selected} sélectionnée | {selected} sélectionnées",
        "set_status_for": "Définir le statut de {name}",
        "status_hint_assignees": "la personne assignée | les personnes assignées",
        "status_hint_customer": "le client",
        "status_hint_sent": "les personnes à qui elle a été envoyée",
        "superseded": "Remplacé",
        "totalSelected": "Les {total} sélectionnées",
        "upload_hint": "Téléversez le ou les documents demandés pour terminer cette tâche."
      },
      "status_hints": {
        "completed": "La tâche est terminée. Elle reste visible pour {who}, sous {completed}.",
        "draft": "Pas encore visible pour {who}. Passe la tâche en {open} pour la partager.",
        "requested": "Visible pour {who}. La tâche doit encore être terminée."
      },
      "statuses": {
        "completed": "Terminé",
        "draft": "Brouillon",
        "requested": "Ouvert"
      },
      "toasts": {
        "bulk_delete": "Tâches retirées",
        "bulk_update": "Tâches mises à jour",
        "completed": "Tâche terminée",
        "create": "Tâche créée",
        "delete": "Personne assignée supprimée",
        "document_added": "Fichier ajouté",
        "document_deleted": "Fichier supprimé",
        "reopened": "Tâche rouverte",
        "update": "Tâche mise à jour"
      }
    }
  }
}
